import store from "@/store";
import config from "@/utils/config";
import request_cho from "@/utils/request_cho";
import request from "@/utils/request";
import statisticsList from "@/assets/json/statisticsList.json";

const getColorJson = (element: string) => {
  let url = "";
  if (element.startsWith("tem")) {
    url = "/cw/choroplethic/color_json/tem";
  } else if (element.startsWith("pre")) {
    url = "/cw/choroplethic/color_json/pre";
  }
  return request.get(url, null).then((data: any) => {
    if (data.length > 0) {
      return data;
    }
  });
};

const getGeoJson = (data: any[], element: string, subId: string) => {
  const knowValues = [];
  const arr = data.filter((e) => {
    return e.value !== "--";
  });
  for (const item of arr) {
    const value = item.value;
    knowValues.push([
      parseFloat(item.lon),
      parseFloat(item.lat),
      parseFloat(value),
    ]);
  }
  if (knowValues.length < 3) {
    return {};
  }
  let ele = "";
  let key = "";
  if (element.indexOf("pre") > -1) {
    ele = "pre";
  }
  if (element.startsWith("tem")) {
    ele = "tem";
  }
  if (subId === "pre") {
    key = "pre_1h";
  } else if (subId === "pre_0808" || subId === "pre_2020") {
    key = "pre_any";
  } else if (subId.startsWith("tem")) {
    key = "tem";
  } else {
    key = subId;
  }
  // @ts-ignore
  const detailStatJson = statisticsList[key].data;
  const colorSettings = [];

  for (const item of detailStatJson) {
    const value = item.value;
    const rgbcolor = item.rgbcolor;
    const myColorSetting = {
      l: value[0],
      h: value[1],
      r: rgbcolor[0],
      g: rgbcolor[1],
      b: rgbcolor[2],
      a: 100,
      desc: "",
    };
    colorSettings.push(myColorSetting);
  }
  const params = {
    areaCode: config.defaultStationObj.adminCode,
    colorSettings: colorSettings,
    type: ele,
    size: 90,
    knowValues,
  };

  // if (ele === "pre") {
  //   //@ts-ignore
  //   params.colorSettings = colorSettings;
  // }
  return request_cho
    .post("/cho_rest/cho", params)
    .then((result: any) => {
      return result;
    })
    .catch((e: any) => console.error(e));
};
export default { getColorJson, getGeoJson };
